import { useCallback } from 'react';

import { useNavigationContext } from '../context';

export const useRouterBackCallback = (url: string) => {
  const { router } = useNavigationContext();
  const onRouterBack = useCallback(() => {
    const historyState = window.history.state;
    if (historyState?.idx > 0) router?.back();
    else if (url) router?.push(url);
  }, [router, url]);
  return { onRouterBack };
};
